import React, { FC, useMemo } from 'react'
import WarningDialog from 'components/libs/dialog/warningDialog/WarningDialog'
import { useRemoveDomainLogic } from 'components/pages/domains/removeDomain/useRemoveDomainLogic'
import { useFormatMessage } from 'lib/localization'

export interface RemoveDomainProps {
  domainName: string | undefined
  domainId: string | undefined
  isDomainMove: boolean | undefined
  onClose: () => void
}

const BASE_I18N_KEY = 'ess.domains'
const DIALOG_I18N_KEY = 'ess.dialog'

export const RemoveDomain: FC<RemoveDomainProps> = ({ domainName, domainId, onClose, isDomainMove }) => {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const formatDialogText = useFormatMessage(DIALOG_I18N_KEY)
  const [state, eventHandlers] = useRemoveDomainLogic({ domainId, onClose, isDomainMove: !!isDomainMove })

  return useMemo(
    () => (
      <WarningDialog
        open={!!domainId}
        title={formatDialogText('delete_domain_domain_name.title', { domainName })}
        description={formatMessage(state.dialogDescription)}
        onCancel={eventHandlers.onClose}
        onClose={eventHandlers.onClose}
        onConfirm={state.isConfirmVisible ? eventHandlers.onConfirm : undefined}
        isPending={state.isPending}
        cancelButtonLabel={formatDialogText('delete_domain_domain_name.cancel')}
        confirmButtonLabel={formatDialogText('delete_domain_domain_name.confirm')}
      />
    ),
    [domainName, domainId, eventHandlers, formatMessage, formatDialogText, state]
  )
}
